// client/src/hooks/useAdminCardOrders.js
// Super-admin: list every CardOrder across every camp, update status.

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

const listKey = (query) => ['admin', 'card-orders', query];

export function useAllCardOrders(query = {}) {
  return useQuery({
    queryKey: listKey(query),
    queryFn: () => api.get('/api/admin/card-orders', { query }),
    placeholderData: (prev) => prev,
  });
}

export function useUpdateCardOrderStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ orderId, status }) =>
      api.patch(`/api/admin/card-orders/${orderId}`, { status }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['admin', 'card-orders'] });
    },
  });
}
